module.exports = __webpack_public_path__ + "media/stockholm/bridge-c285d909.jpg";